(ns common.schema.entities.ai-job-enrichment.permissions
  (:require [common.roles :as roles]))

(defn read-permissions?
  "An enrichment job is readable by the account that requested it or by an admin."
  [{:keys [account entity role]}]
  (or (roles/admin? role)
      (= (:db/id account)
         (:db/id (:ai-job-enrichment/account entity)))))

(defn disable-permissions?
  [{:keys [tr]}]
  (tr :not-allowed))
